import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import AddPhotoAlternateRounded from "@mui/icons-material/AddPhotoAlternateRounded";
import { Box, Collapse, IconButton, Typography } from "@mui/material";
import { t } from "i18next";
import { $getRoot } from "lexical";
import { type FC, useCallback, useRef, useState } from "react";
import { useDialog } from "../../../../utils/hooks/use-dialog";
import { $isDesignHuddleNode } from "../nodes/design-huddle-node";
import { $isImageNode } from "../nodes/image-node";
import { AddImagesAndFilesModal } from "./toolbar/add-images-and-files-modal";

export const ImagePromptPlugin: FC<{ disabled: boolean }> = ({ disabled }) => {
  const [editor] = useLexicalComposerContext();
  const [showPrompt, setShowPrompt] = useState(!disabled);
  const inputFile = useRef<HTMLInputElement>(null);
  const dialog = useDialog();

  const handle = useCallback(() => {
    if (disabled) return setShowPrompt(false);

    editor.getEditorState().read(() => {
      const hasImage = $getRoot()
        .getChildren()
        .some((x) => $isImageNode(x) || $isDesignHuddleNode(x));

      setShowPrompt(!hasImage);
    });
  }, [editor, disabled]);

  return (
    <>
      <OnChangePlugin onChange={handle} ignoreHistoryMergeTagChange ignoreSelectionChange />
      <Collapse in={showPrompt}>
        <Box>
          <IconButton
            data-analytics-id="lexical-image-prompt"
            onClick={() => inputFile?.current?.click()}
            sx={{
              width: "100%",
              backgroundColor: "background.active",
              borderTopRightRadius: 0,
              borderTopLeftRadius: 0,
              p: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }} onClick={dialog.handleOpen}>
              <AddPhotoAlternateRounded sx={{ pr: 1 }} fontSize="large" color="primary" />
              <Typography>{t("Add an image to boost engagement on this Communication")}</Typography>
            </Box>
          </IconButton>
        </Box>
      </Collapse>
      {dialog.open && (
        <AddImagesAndFilesModal
          open={dialog.open}
          onClose={() => {
            dialog.handleClose();
          }}
        />
      )}
    </>
  );
};
